import { Button, Form } from "rsuite";
import { EmailEditForm } from "./EditEmailForm.component";
import {
  BlackListEmailAddFormType,
  BlackListEmailAddDefaultValues,
  BlackListEmailAddFormSchema,
} from "../../models/forms/blackListEmailAddForm";
import { useState, FormEvent } from "react";

export const EditEmail = () => {
  const [formValue, setFormValue] = useState<BlackListEmailAddFormType>(
    BlackListEmailAddDefaultValues
  );

  const handleSave = (checked: boolean, event: FormEvent<HTMLFormElement>) => {
    if (!checked) return;
    console.log(formValue);
    setFormValue(BlackListEmailAddDefaultValues);
  };
  return (
    <div className="black-list-email-card">
      <div className="d-flex flex-column px-2">
        <h6 className="mb-3 mt-2">Email Domain Information</h6>
        <p className="fw-bold mt-3 card-text">Name</p>
        <Form
          formValue={formValue}
          onChange={setFormValue}
          model={BlackListEmailAddFormSchema}
          onSubmit={handleSave}
          fluid
        >
          <EmailEditForm />
          <p className="mt-2 card-text"> Example: google.com</p>
          <div className="d-flex justify-content-end align-items-center mb-3">
            <Button
              size="sm"
              appearance="primary"
              type="submit"
              className="form-buttons"
            >
              Update
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
